export enum SupportedBankPayment {
    CITY_BANK = "City",
    EASTERN_BANK = "EBL",
    BRAC_BANK = "Brac",
    DBBL = "DBBL",
}

export enum SupportedOtherPayment {
    NEXUSPAY = "NexusPay",
    AMEX = "Amex",
    CASH = "Cash",
    CHEQUE = "Cheque",
    BKASH = "Bkash",
    NAGAD = "Nagad",
}
